<PaymentButton class="kr-popin-button" v-if="isVisible" v-show="showing" type="button" :class="dynamicClasses" :style="styles" @click="open()"></PaymentButton>